import { Button, Col, Modal, Row, Spin, Alert } from 'antd';
import React, { useEffect, useState } from 'react';
import { initMercadoPago, Payment } from '@mercadopago/sdk-react'
import { getGenerarPago, getGenerarPreferencia } from '../peticiones';
import { useNavigate } from 'react-router-dom';

initMercadoPago('TEST-51789405-b9d3-4b38-95dd-df049cd8533a', { locale: "es-MX" });


const PaymentMethod = (props) => {


    const { verMetodosPago, setverMetodosPago, setverEstatusScreen, setinformacionCompra, producto, cantidad, precioUnitario, idPaseMedico } = props;

    const [initialization, setinitialization] = useState(null);
    const [verSpinning, setverSpinning] = useState(false);

    let navigate = useNavigate();


    useEffect(() => {
        if (producto !== null && cantidad !== null && precioUnitario > 1 && verMetodosPago === true) {
            setverSpinning(true);
            crearObjeto();
        }
    }, [producto, cantidad, precioUnitario, verMetodosPago]);

    const crearObjeto = async () => {
        const preferenceId = await generarPreference(producto, cantidad, precioUnitario, idPaseMedico);
        // console.log(preferenceId, "preferenceId");

        // Verificamos si preferenceId es undefined
        if (!preferenceId) {
            // console.log("preferenceId es undefined, reintentando...");
            return crearObjeto(); // Reintentamos crear el objeto llamando de nuevo a la función
        }

        const objeto = {
            amount: precioUnitario,
            preferenceId: preferenceId,
        };
        setinitialization(objeto);
        setverSpinning(false);
    }


    const generarPreference = async (producto, cantidad, precioUnitario, idPaseMedico) => {
        const respuesta = await getGenerarPreferencia({ producto, cantidad, precioUnitario, idPaseMedico });
        // console.log(respuesta);
        if (respuesta.ok === true && respuesta.data && respuesta.data.id) {
            return (respuesta.data.id);
        }

    }

    const customization = {
        paymentMethods: {
            creditCard: "all", // Permitir tarjetas de crédito
            debitCard: "all",  // Permitir tarjetas de débito
            mercadoPago: "all" // Permitir Mercado Pago
        },
        installments: 1,   // Establecer la cantidad de cuotas en 1 (sin meses sin intereses)
        default_installments: 1, // Cuota predeterminada en 1
    };


    const onSubmit = async ({ selectedPaymentMethod, formData }) => {
        // callback llamado al hacer clic en el botón enviar datos

        setverSpinning(true);
        const respuesta = await getGenerarPago({ descripcion: "Pago de pase médico", metodoPago: formData.payment_method_id, email: formData.payer.email, transaction_amount: formData.transaction_amount, token: formData.token, issuer_id: formData.issuer_id, installments: formData.installments });
        console.log(respuesta, "respuesta");
        if (respuesta.ok === false) {
            return onSubmit({ selectedPaymentMethod, formData });
        }

        setverSpinning(false);
        setinformacionCompra(respuesta);
        setverMetodosPago(false);
        setverEstatusScreen(true);
    };

    const onError = async (error) => {
        // callback llamado para todos los casos de error de Brick
        console.log(error);
    };
    const onReady = async (objeto) => {
        console.log(objeto);
    };


    return (

        <Modal open={verMetodosPago} title={<><h3 style={{ fontSize: '1.5vw', margin: 0 }}>Métodos de pago:</h3></>} closeIcon={<></>}

            footer={<Row gutter={16}>
                <Col span={24} style={{ marginTop: "2%" }}><Button type="default" size='large' block onClick={() => navigate(-1)}>Regresar</Button></Col>
            </Row>}
        >
            <Spin spinning={verSpinning}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Alert
                                description="La información que nos proporciones será validada por uno de nuestros agentes."
                                type="warning"
                                showIcon
                            />
                        </Col>
                        <Col span={24}>
                            {initialization && initialization.amount > 0 && (
                                <Payment
                                    initialization={initialization}
                                    customization={customization}
                                    onSubmit={onSubmit}
                                    onReady={onReady}
                                    onError={onError}
                                />
                            )}
                        </Col>
                    </Row>
                </div>
            </Spin>
        </Modal>
    )
}

export default PaymentMethod;
